// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 100px 0 36px 0;
}
.products-left {
  display: flex;
  flex-direction: column;
  flex: 3 1;
}
.products-left-title {
  font-size: 24px;
  font-weight: 700;
  color: #fefefe;
  margin-bottom: 16px;
}
.products-left-active {
  color: #6e00ff !important;
}
.products-left span {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #898989;
  cursor: pointer;
}
.products-left span:hover {
  color: #6e00ff;
}
.products-right {
  flex: 9 1;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.products-mobile {
  width: 100%;
  display: none;
  flex-direction: column;
}
.products-mobile-item {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  margin-top: 10px;
  padding: 0 10px;
  box-sizing: border-box;
}
.products-mobile-item img {
  width: 40px;
  height: 40px;
}
.products-mobile-item span {
  text-align: center;
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #fefefe;
}

@media (max-width: 576px) {
  .products {
    padding: 10px 0;
  }
  .products-left {
    display: none;
  }
  .products-right {
    display: none;
  }
  .products-mobile {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ProductsListPage/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEJ;AADI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAGN;AADI;EACE,yBAAA;AAGN;AADI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAGN;AAFM;EACE,cAAA;AAIR;AAAE;EACE,SAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;AAEJ;AAAE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;AAIR;AAFM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAIR;;AAEA;EACE;IACE,eAAA;EACF;EAAE;IACE,aAAA;EAEJ;EAAE;IACE,aAAA;EAEJ;EAAE;IACE,aAAA;EAEJ;AACF","sourcesContent":[".products {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 100px 0 36px 0;\n  &-left {\n    display: flex;\n    flex-direction: column;\n    flex: 3;\n    &-title {\n      font-size: 24px;\n      font-weight: 700;\n      color: #fefefe;\n      margin-bottom: 16px;\n    }\n    &-active {\n      color: #6e00ff !important;\n    }\n    & span {\n      margin-top: 16px;\n      font-size: 16px;\n      font-weight: 500;\n      color: #898989;\n      cursor: pointer;\n      &:hover {\n        color: #6e00ff;\n      }\n    }\n  }\n  &-right {\n    flex: 9;\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n  &-mobile {\n    width: 100%;\n    display: none;\n    flex-direction: column;\n    &-item {\n      width: 100%;\n      height: 70px;\n      display: flex;\n      align-items: center;\n      background-color: #00000033;\n      border-radius: 12px;\n      margin-top: 10px;\n      padding: 0 10px;\n      box-sizing: border-box;\n      & img {\n        width: 40px;\n        height: 40px;\n      }\n      & span {\n        text-align: center;\n        margin-left: 10px;\n        font-size: 16px;\n        font-weight: 500;\n        color: #fefefe;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .products {\n    padding: 10px 0;\n    &-left {\n      display: none;\n    }\n    &-right {\n      display: none;\n    }\n    &-mobile {\n      display: flex;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
